<template>
<div>

  <div class = "section columns is-centered endarea">
    <div class = "column is-6">
        <div class = "section">
            <div class = "title title-font"> Solicita tu presupuesto </div>
            <div style = "text-align: left">
              <ul class = "list-style">
                <li> Escribe tus datos. </li>
                <li> Describe el trabajo a realizar. </li>
                <li> No olvides añadir para cuándo lo necesitas. </li>
                <li> Nos sería de gran utilidad que nos enviaras fotografías. </li>
              </ul>
            </div>
            <br>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Nombre</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input class="input" :class = "{'is-danger': nameWrong}" type="text" placeholder="Introduce tu nombre" v-model = "name">
                  </div>
                  <p class="help is-danger" v-show = "nameWrong">
                    Este campo es requerido
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Email</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input class="input" :class = "{'is-danger': emailWrong}" type="email" placeholder="Introduce tu email" v-model = "email">
                  </div>
                  <p class="help is-danger" v-show = "emailWrong">
                    Este campo es requerido
                  </p>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Teléfono</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input class="input" :class = "{'is-danger': phoneWrong}" type="tel" placeholder="Introduce tu teléfono" v-model = "phone">
                  </div>
                  <p class="help is-danger" v-show = "phoneWrong">
                    Este campo es requerido
                  </p>
                </div>
              </div>
            </div>

            <div class = "field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Mensaje</label>
              </div>
              <div class = "field-body">
                <div class = "field">
                  <div class = "control">
                    <textarea class="textarea" :class = "{'is-danger': messageWrong}" v-model = "message" placeholder="Escribe tu mensaje aquí"></textarea>
                  </div>
                  <p class="help is-danger" v-show = "messageWrong">
                    Este campo es requerido
                  </p>
                </div>
              </div>
            </div>

            <div class = "field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Fotografías</label>
              </div>
              <div class = "field-body">
                <div class = "field">
                  <div class="dropbox">
                    <input type="file" ref="files" @change="handleFiles()" multiple
                      accept="image/*" class="is-overlay input-file" >
                      <p >
                        Arrastra tus fotos aquí<br> o haz click para examinar
                      </p>
                  </div>
                </div>
              </div>
            </div>
            <div class = "columns is-multiline is-mobile is-centered">
              <div class = "column is-4" v-for="(file,index) in files" :key="file.name">
                
                <div class = "tag is-primary is-large is-light">
                  
                  <figure class = "image is-32x32 tag-image">
                    <img v-bind:ref="'image'+parseInt( index )" style = "height: 100%; width: 100%; object-fit: contain"/>
                  </figure>
                  
                  <span class = "is-size-6"> {{sanitizeFilename(file.name)}} </span>

                  <a class = "is-size-5 has-text-white" style = "margin-left: 0.5rem;" @click = "files.pop(index)"> <font-awesome-icon class = "" :icon = "['fas', 'times-circle']"/> </a>
                </div>
              </div>
            </div>
            <div class = "field">
                <div class = "control">
                  <a class ="button is-success" :class = "{'is-loading': isSending}"  @click = "sendMessage" > Enviar </a>
                </div>
            </div>
        </div>

    </div>

  </div>

  <div class="modal" :class="{'is-active': messageSent}">
    <div class="modal-background"></div>
    <div class="modal-content">
      <header class="modal-card-head">
        <p class="modal-card-title">¡Gracias por tu mensaje!</p>
        <button class="delete" @click="goToMain()"></button>
      </header>
      <section class="modal-card-body">
        Recibirás una respuesta pronto
      </section>
      <footer class="modal-card-foot">
        <a class="button is-primary"  @click="goToMain()">OK</a>
      </footer>
    </div>
    <button class="modal-close is-large" ></button>
  </div>

  <div class="modal" :class="{'is-active': messageError}">
    <div class="modal-background"></div>
    <div class="modal-content">
      <header class="modal-card-head">
        <p class="modal-card-title">Tu mensaje no ha podido enviarse</p>
        <button class="delete" @click="messageError = false"></button>
      </header>
      <section class="modal-card-body">
        Asegúrate de que las imágenes no ocupan más de 50 MB, tienen formato jpg o png y vuelve a intentarlo.
      </section>
      <footer class="modal-card-foot">
        <a class="button is-primary"  @click="messageError = false">OK</a>
      </footer>
    </div>
    <button class="modal-close is-large" ></button>
  </div>

</div>
</template>

<script>

import {requester} from '../App.vue';
import _ from 'lodash';

export default {
  name: 'Budget',
  data() {
    return { 
      name: "",
      email: "",
      message: "",
      phone: "",
      nameWrong: false,
      emailWrong: false,
      messageWrong: false,
      phoneWrong: false,
      messageSent: false,
      isSending: false,
      messageError: false,
      files: []
    }
  },
  methods: {
    sendMessage: _.debounce(function(){

      if(!this.name){
        this.nameWrong = true;
      } else {
        this.nameWrong = false;
      }
      

      var emailPattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
      if(!emailPattern.test(this.email)){
        this.emailWrong = true;
      } else {
        this.emailWrong = false;
      }
      

      if(!this.message){
        this.messageWrong = true;
      } else {
        this.messageWrong = false;
      }
      

      if(isNaN(this.phone)){
        this.phoneWrong = true;
      } else {
        this.phoneWrong = false;
      }

      if(this.nameWrong || this.emailWrong || this.messageWrong || this.phoneWrong){
        return;
      }


      let formData = new FormData();
      formData.append('name', this.name);
      formData.append('email', this.email);
      formData.append('phone', this.phone);
      formData.append('message', this.message);

      for( var i = 0; i < this.files.length; i++ ){
        let file = this.files[i];

        formData.append('files[' + i + ']', file);
      }

      this.isSending = true;

      requester.post('contact', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      },
      ).then(() => {
        this.name = "";
        this.email = "";
        this.phone = "";
        this.message = "";
        this.files = [];
        this.isSending = false;
        this.messageSent = true;
      }).catch(() => {
        this.isSending = false;
        this.messageError = true;
      })

    }, 200, {leading: true}),

    handleFiles: function(){

      for(let i = 0; i < this.$refs.files.files.length; i++){
        this.files.push(this.$refs.files.files[i]);
      }

      if(this.files){

        for(let i = 0; i < this.files.length; i++){
          var reader = new FileReader();
          reader.onload = (event) => {
            this.$refs['image'+parseInt( i )][0].src = event.target.result;
          }
          reader.readAsDataURL(this.files[i]);
        }
      }
      
    },
    sanitizeFilename: function(fileName){
      let trimmed = fileName.trim();
      if(fileName.length > 10){
        trimmed = trimmed.substring(0,10) + "...";
      }

      return trimmed;
    },
    getImage: function(preview){
      if(preview){
        return preview + "";
      } else {
        return require('../../public/fotos/placeholder.png');
      }
    },
    goToMain: function(){
      this.$router.push("/");
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang = "scss">
.title-font {
  font-family: "Baloo Bhaina 2";
}

h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
  font-family: 'Century Gothic', 'Tahoma', 'Verdana'
}
.footer {
  background-color: #222222;
}

.list-style {
  list-style-position: inside;
  padding: 2px;
  list-style-type:disc;
}

.dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }

.dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

.tag-image {
  margin-right: 0.5rem; 
  margin-top: auto; 
  margin-bottom: auto;
}
</style>
